// Pixi Application + container hierarchy.
//
// Layers (back to front):
//   worldLayer    — hex grid edges (static, 3×3 tiled)
//   bouncerLayer  — static hazards
//   entitiesLayer — pellets, player dots + rings + labels
// HUD is plain DOM above the canvas (render/hud.ts).

import { Application, Container } from 'pixi.js';
import { theme } from './theme.js';

export interface Stage {
  app: Application;
  worldLayer: Container;
  bouncerLayer: Container;
  entitiesLayer: Container;
  destroy(): void;
}

export async function createStage(root: HTMLElement): Promise<Stage> {
  const app = new Application();
  await app.init({
    background: theme.background,
    resizeTo: window,
    antialias: true,
  });
  root.appendChild(app.canvas);

  const worldLayer = new Container();
  const bouncerLayer = new Container();
  const entitiesLayer = new Container();
  app.stage.addChild(worldLayer);
  app.stage.addChild(bouncerLayer);
  app.stage.addChild(entitiesLayer);

  return {
    app,
    worldLayer,
    bouncerLayer,
    entitiesLayer,
    destroy() {
      app.destroy(true, { children: true });
      if (app.canvas.parentNode === root) root.removeChild(app.canvas);
    },
  };
}
